@if (btnConfig.isStroked) {
  <button
    mat-stroked-button
    color="primary"
    [class]="btnConfig.class"
    [class.fade-disabled]="btnConfig.fadeDisabled"
    [ngStyle]="btnConfig.buttonStyle"
    [disabled]="btnConfig.disabled?.() || spinLoader"
    [id]="btnConfig.id"
    [type]="btnConfig.type ?? 'button'"
    (click)="btnConfig.onClick?.()"
  >
    <div class="d-flex align-items-center text-disable">
      <ng-container *ngTemplateOutlet="icon" />
      {{ ButtonText | translate }}
    </div>
  </button>
} @else {
  <button
    mat-flat-button
    color="primary"
    [class]="btnConfig.class"
    [class.fade-disabled]="btnConfig.fadeDisabled"
    [id]="btnConfig.id"
    [ngStyle]="btnConfig.buttonStyle"
    [disabled]="btnConfig.disabled?.() || spinLoader"
    [type]="btnConfig.type ?? 'button'"
    (click)="btnConfig.onClick?.()"
  >
    <div class="d-flex align-items-center text-disable">
      <ng-container *ngTemplateOutlet="icon" />
      {{ ButtonText | translate }}
    </div>
  </button>
}

<ng-template #icon>
  @if (spinLoader && !btnConfig.isStroked) {
    <div class="loading-container">
      <mat-icon>hourglass_empty</mat-icon>
    </div>
  } @else {
    <i-tabler *ngIf="btnConfig.icon" class="icon-20 m-r-8" [name]="btnConfig.icon" />
  }
</ng-template>
